export const BASE_PATH = ""
export const BASE_API_PATH = "/api"